import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { Suspense } from 'react';
import ScrollToTop from './component/layout/ScrollToTop';
import Layout from './component/layout/Layout';
import Home from './pages/home/Home';
import AboutCoach from './pages/otherpages/AboutCoach';
import Payment from './pages/otherpages/Payment';
// import CalendlyEvents from './pages/home/CalendlyEvents';
// import CalendlyEvents from './pages/home/CalendlyEvents';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Privacy from './pages/otherpages/Privacy';
// import Error from './pages/otherpages/Error';
// import ComingSoon from './pages/otherpages/ComingSoon';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense >
          <ScrollToTop />
          <Routes>
            {/* <Route path="/" element={<Error/>}/> */}
            <Route path="/" element={<Layout><Home/></Layout>}/>
            <Route path="/know-your-coach" element={<Layout><AboutCoach/></Layout>}/>
            <Route path='/checkout' element={<Layout><Payment/></Layout>} />
            <Route path='/privacy' element={<Layout><Privacy/></Layout>} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={5000} style={{zIndex: "50000"}}/> 
    </div>
  );
}

export default App;
